import { useEffect } from 'react';
import { useFilterLogic } from './useFilterLogic';
import { useFilterV2 } from './useFilterV2';
import {
  getSelectedValue,
  FILTER_ORDER_V2,
} from '@components/FilterBar/utils/filterAdapterV2';

/**
 * Enhanced hook that bridges legacy filter logic with new PsdFilter Redux state
 * Redux is used as the default/storage layer for PsdFilter components
 * Filter context is updated via onChange callbacks for backward compatibility
 *
 * @param {Object} options - Configuration options
 * @param {boolean} options.hideR360PP - Whether to hide R360PP filters
 * @returns {Object} Combined filter logic and V2 filter state
 */
export const useFilterLogicV2 = ({ hideR360PP = false } = {}) => {
  // Get legacy filter logic
  const filterLogic = useFilterLogic({ hideR360PP });

  // Get V2 filter hooks
  const { updateFilterValue } = useFilterV2();

  // One-time sync: Initialize Redux with legacy context values on mount
  // This ensures PsdFilter components start with the correct default values
  // Using setTimeout to defer state updates and avoid "Cannot update a component
  // while rendering a different component" warning
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      FILTER_ORDER_V2.forEach((filterKey) => {
        const legacyValue = getSelectedValue(filterKey, filterLogic);

        // Initialize Redux with legacy value if it exists
        if (legacyValue !== undefined && legacyValue !== null) {
          updateFilterValue(filterKey, legacyValue);
        }
      });
    }, 0);

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount

  return filterLogic;
};

export default useFilterLogicV2;
